import type { Ride, RidePoint } from './ride';

/** A summary-only timer is interpolated over original timestamps; pause positions are unknown. */
export function sectionTimerDuration(source: Pick<Ride, 'points' | 'sourcePoints' | 'timerDurationSeconds'>,
  section: readonly RidePoint[]): number | undefined {
  if (source.timerDurationSeconds === undefined) return undefined;
  const points = source.sourcePoints ?? source.points;
  const elapsed = Date.parse(points.at(-1)!.recordedAt) - Date.parse(points[0]!.recordedAt);
  const selected = Date.parse(section.at(-1)!.recordedAt) - Date.parse(section[0]!.recordedAt);
  return elapsed === 0 ? source.timerDurationSeconds : source.timerDurationSeconds * (selected / elapsed);
}
